export default "__VITE_ASSET__6e552858__"